<header class="navbar navbar-expand w-100 shadow-sm fixed-top p-2 d-flex justify-content-between">

  <div class="logo-container">
    <img src="assets/FXCH.v2.1.png" alt="fxch-logo" height="100%"/>
  </div>

  <div class="navbar-text">
      <ul class="navbar-nav mb-2 mb-lg-0">

      <li class="nav-item">
        <a class="nav-link" href="#" (click)="sidenav.open()">FAQ</a>
      </li>
      </ul>
  </div>
</header>


<mat-sidenav-container class="sidenav-container" [hasBackdrop]="false" [ngClass]="{'bg-primary': darkModeService.darkModeSignal() === 'dark'}">
  <mat-sidenav #sidenav
               mode="push"
               class="sidenav"
               position="end"
               [fixedInViewport]="true"
               [fixedTopGap]="5"
               [fixedBottomGap]="0">

    <div class="close-pane-container"
         (click)="sidenav.toggle()">
      <i class="fa fa-2x fa-times"></i>
    </div>

    <h1>FAQ</h1>
    <p>
      Quisque posuere viverra massa, vel sollicitudin sapien laoreet sed. Integer tincidunt ultricies luctus. Maecenas ac auctor ex, non vestibulum augue. Cras rhoncus consectetur facilisis. Vestibulum ut ultricies mauris. Suspendisse quis arcu cursus, fringilla nisl id, porttitor lacus. Mauris varius malesuada dictum. Cras non arcu tempor, suscipit est sit amet, tempor felis. Curabitur at egestas odio.
    </p>
  </mat-sidenav>

<div class="login-container container-fluid d-flex">


<div class="container align-self-center">
  <div class="row mb-5 text-center">
    <h1 class="display-4 text-info" [ngClass]="{'text-secondary': darkModeService.isDarkModeOn()}">Welcome to The FX Clearing House</h1>
  </div>
  <div class="row d-flex justify-content-center align-items-center">
<!--  <div class="col-md-13 col-xxl-15">-->


<!--    <p class="text-justify">Aliquam sollicitudin eros lobortis purus mollis interdum et nec elit. Ut et posuere lorem. Vivamus vitae felis lectus. Nullam consequat turpis eu leo interdum bibendum. Phasellus justo massa, ultrices at viverra tincidunt, volutpat a dui. Vestibulum egestas at nulla eu placerat. Donec ipsum urna, scelerisque sit amet varius vel, dictum sed nulla. Suspendisse accumsan a quam a varius. Etiam neque massa, lobortis vel tortor sed, dignissim rhoncus massa. Etiam cursus dapibus ante, eu venenatis purus eleifend ac. Sed ornare turpis et eros aliquet elementum. Cras a condimentum metus. Nulla volutpat, lectus id suscipit pulvinar, lorem nisl ultricies ex, nec dictum ante erat sed leo. Vivamus ullamcorper ante augue, mollis dignissim ante vehicula eget. Sed nec tempor sem, quis volutpat eros.</p>-->

<!--  </div>-->
  <div class="col-23 col-sm-24 col-md-20 col-lg-16 col-xl-12">
<!--    <div class="card">-->
<!--      <div class="card-body">-->
<!--        <h4 class="card-title text-center text-uppercase">Please sign in</h4>-->
    <baxter-auth [direction]="" (successLogin)="successLogin()" [toastrService]="toastrService" [application]="'CLEARING_HUB'"></baxter-auth>


<!--    <ng-template #test></ng-template>-->
<!--    <lib-auth></lib-auth>-->
<!--      </div>-->

      <!--  <mat-card-footer class="bg-dark">-->
      <!--    <div><img src="assets/images/logo.png" alt="baxter"></div>-->
      <!--  </mat-card-footer>-->

<!--    </div>-->
  </div>
  </div><!--  // row-->
</div><!--  // container-->

</div>

</mat-sidenav-container>
